import PropTypes from 'prop-types'

export default PropTypes.shape({
  itemsPerPage: PropTypes.number,
  totalNumberOfItems: PropTypes.number,
})
